export enum ThirdPartyBannerSpace {
  LANDING_PAGE          = "landing-page",
  ADS_LISTING_TOP       = "ads-listing-top",
  ADS_LISTING_RIGHT     = "ads-listing-right",
  ADS_LISTING_LEFT      = "ads-listing-left",
}
